import React from 'react';
import { Col, FormGroup, Row } from "react-bootstrap";
import { Switch, CurrencyBox } from "fw/forms";
import { CommentsGrid, ReviewUpload, AdminAppIdHeader } from 'areas/shared/components';
import { SetupTab } from 'areas/shared/pages/setup';
import { Label, ActionButton, Button } from 'fw/components';
import ReviewPanel from 'areas/admin/certification/shared/ReviewPanel';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import * as ReportManager from 'modules/reports/ReportManager';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import { QueueType, TooltipCode } from 'areas/shared/consts';

class EquipmentInfo extends SetupTab {
    initialForm() {
        return {
            rowVersion: null,
            reviewComment: '',
            tooltips: []
        }
    }

    skipValidations() {
        return App.hasPrivilege("AdminSkipValidations");
    }

    isEnabled(data) {
        return !data.isReviewFinished;
    }

    isValidated(data) {
        return data.isSubmitted;
    }

    ready = () => {
        // If currentStep is disabled (fastTrack), then go to tab "Cert."
        const currentStepIndex = this.props.setupProps.tabs.findIndex(tab => tab.key === "equipmentInfo");
        if (this.props.setupProps.tabs[currentStepIndex].disabled)
            this.props.handleTabSelect("businessCertification");

        // Add an Asset Purchase Agreement (APA) document control to be filled
        if (this.state.form.apaDocuments !== undefined && this.state.form.apaDocuments.length === 0)
            this.addApaDocument();
        // Add an Equipment Lease Agreement (ELA) document control to be filled
        if (this.state.form.elaDocuments !== undefined && this.state.form.elaDocuments.length === 0)
            this.addElaDocument();
    }

    updatePostData = (form, dirty) => {
        if (this.state.form.showComplete)
            this.validateReviewStatus(form);
        this.setState({ form });

        if (dirty === true)
            this.dirt();
    }

    validateReviewStatus = (form) => {
        let canComplete=
        (
            this.state.form.certificationQueueTypeCode !== QueueType.APPLICATION_REVIEW.code &&
            this.state.form.certificationQueueTypeCode !== QueueType.CERTIFICATION_REVIEW.code &&
            this.state.form.certificationQueueTypeCode !== QueueType.COMMITTEE_REVIEW.code
        ) ||
        (this.state.form.apaDocuments.every((document) => { return document.uploadModel && document.uploadModel.validDocument; })
            && this.state.form.elaDocuments.every((document) => { return document.uploadModel && document.uploadModel.validDocument; }));

        if (form.reviewStatus !== null && form.reviewStatus !== undefined && form.reviewStatus && !canComplete)
            form.reviewStatus = false;
    }

    beforeSave = (cb) => {
        this._ast.checkReviewStatus(cb);
    }

    privileges() {
        return {
            edit: App.hasPrivilege("AdminAppManagementEdit")
        }
    }

    urls() {
        return {
            get: API.Admin.url('/certification/getEquipmentInfo'),
            save: API.Admin.url('/certification/saveEquipmentInfo'),
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId,
            queueTypeCode: this.props.queueTypeCode
        }
    }

    saveRequest() {
        return {
            certificationId: this.state.form.certificationId,
            entityId: this.state.form.savedEntityId,
            tangibleEquipmentAmount: this.state.form.tangibleEquipmentAmount,
            locationEquipment: this.state.form.locationEquipment,
            personalLocation: this.state.form.personalLocation,
            businessLocation: this.state.form.businessLocation,
            warehouseLocation: this.state.form.warehouseLocation,
            garageLocation: this.state.form.garageLocation,
            mobileStorageLocation: this.state.form.mobileStorageLocation,
            apaDocuments: this.state.form.apaDocuments,
            elaDocuments: this.state.form.elaDocuments,
            rowVersion: this.state.form.rowVersion,
            reviewStatus: this.state.form.reviewStatus,
            reviewQueueTypeCode: this.state.form.certificationQueueTypeCode,
            reviewComment: this.state.reviewComment
        }
    }

    handleUploadApaDocumentChange = (file, index) => {
        let form = this.state.form;

        form.apaDocuments[index].storageToken = file.storageToken;
        form.apaDocuments[index].fileName = file.fileName;

        this.updatePostData(form, true);
    };

    handleReviewUploadApaDocumentChange = (formUpload, index) => {
        let form = this.state.form;

        form.apaDocuments[index].uploadModel = formUpload;

        this.updatePostData(form, true);
    }

    handleRemoveApaDocument = (e, i) => {
        e.preventDefault();
        let form = this.state.form;
        form.apaDocuments.splice(i, 1);

        this.updatePostData(form, true);
    }

    addApaDocument = () => {
        let form = this.state.form;
        form.apaDocuments.push({
            equipmentDocumentId: -Math.abs(Date.now() | 0)
        });

        this.updatePostData(form);
    };

    renderApaDocuments = () => {
        return this.state.form.apaDocuments.map((item, index) => {
            let removeComponent =
                index > 0 ?
                    <Col md={1} style={{ marginTop: 5, textAlign: "left", marginLeft: -25, paddingLeft: 0 }}>
						<Button type="button" bsStyle="link" onClick={(e) => this.handleRemoveApaDocument(e, index)} title="Remove Financial Document">
                            <FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
						</Button>
                    </Col>
                    : null;

            return (
                <Row key={item.equipmentDocumentId}>
                    <Col md={12}>
                        <ReviewUpload
                            reviewUpload={item.uploadModel}
                            reviewDisabled={this.state.form.isRenewal}
                            onChange={formUpload => this.handleReviewUploadApaDocumentChange(formUpload, index)}
                            notApplicableAvailable={false}
                            queueTypeCode={this.state.form.certificationQueueTypeCode}
                            wrapFileNameLength={30}
                            toolbarComponent={removeComponent} />
                    </Col>
                </Row>
            )
        });
    };

    handleUploadElaDocumentChange = (file, index) => {
        let form = this.state.form;
        form.elaDocuments[index].storageToken = file.storageToken;
        form.elaDocuments[index].fileName = file.fileName;

        this.updatePostData(form, true);
    };

    handleReviewUploadElaDocumentChange = (formUpload, index) => {
        let form = this.state.form;

        form.elaDocuments[index].uploadModel = formUpload;

        this.updatePostData(form, true);
    }

    handleRemoveElaDocument = (e, i) => {
        e.preventDefault();
        let form = this.state.form;
        form.elaDocuments.splice(i, 1);

        this.updatePostData(form, true);
    }

    addElaDocument = () => {
        let form = this.state.form;
        form.elaDocuments.push({
            equipmentDocumentId: -Math.abs(Date.now() | 0)
        });

        this.updatePostData(form);
    };

    renderElaDocuments = () => {
        return this.state.form.elaDocuments.map((item, index) => {
            let removeComponent =
                index > 0 ?
                    <Col md={1} style={{ marginTop: 5, textAlign: "left", marginLeft: -25, paddingLeft: 0 }}>
						<Button type="button" bsStyle="link" onClick={(e) => this.handleRemoveElaDocument(e, index)} title="Remove Financial Document">
                            <FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
						</Button>
                    </Col>
                    : null;

            return (
                <Row key={item.equipmentDocumentId}>
                    <Col md={12}>
                        <ReviewUpload
                            reviewUpload={item.uploadModel}
                            reviewDisabled={this.state.form.isRenewal}
                            onChange={formUpload => this.handleReviewUploadElaDocumentChange(formUpload, index)}
                            notApplicableAvailable={false}
                            queueTypeCode={this.state.form.certificationQueueTypeCode}
                            toolbarComponent={removeComponent}
                            wrapFileNameLength={30}
                        />
                    </Col>
                </Row>
            )
        });
    };

    handleFacilityUploadChange = (file) => {
        let form = this.state.form;
        form.facilityStorageToken = file.storageToken;
        form.facilityFileName = file.fileName;

        this.updatePostData(form, true);
    };

    handlePrint = () => {
        const rq = Object.assign({
            reportType: "EquipmentInfoReport",
            format: "PDF",
            parameters: {
                CertificationId: this.state.form.certificationId
            }
        });

        ReportManager.execute(rq);
    };

    handleReviewStatus = (formReview) => {
        let form = this.state.form;
        form["reviewStatus"] = formReview.isReviewCompleted;

        this.updatePostData(form, true);
    };

    handleStepCommentSave = (formParam, callback) => {
        let form = this.state.form;

        if (formParam && formParam.comments)
            form.comments = formParam.comments;

        this.updatePostData(form, false);

        if (callback)
            callback();
        else
            this.handleSubmit();
    }

    handleAdminStepToolbar = () => {
        this.handleSubmit();
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments) {
        let form = {
            ...this.state.form,
            comments
        };
        this.updatePostData(form, false);
    }

    afterSave = (entityId, data) => {
        this.addCommentFromSave(data.reviewComment);
    }

    addCommentFromSave = (comment) =>{
        if (comment === null) 
            return;
           
        let comments = this.state.form.comments;
                
        comments.unshift({
            commentId: comment.commentId,
            reviewTypeDescription: comment.reviewTypeDescription,
            queueTypeDescription: comment.queueTypeDescription,
            content: comment.content,
            addedDate: comment.addedAt,
            addedBy: comment.addedBy,
            commentTypeCode: comment.commentTypeCode
        });

        let form = {
            ...this.state.form,
            comments
        };

        this.updatePostData(form, false);

        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });

    }

    renderAdminStepToolbar = () => {
        const disableCancel = !this.state.buttons.cancel;
        //Show cancel
        const showCancel = this.state.showButtons.cancel;
        //Show save 
        const showSave = this.state.showButtons.save && this.state.enabled;
        
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                onCommentSave={this.handleStepCommentSave}
                onSave={this.handleAdminStepToolbar}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'EQ'}
                queueTypeCode={this.state.form.certificationQueueTypeCode}
                reviewStatus={this.state.form.reviewStatus}
                comments={this.state.form.comments}
                showCancel={(showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                showSave={(showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                onCancel={this.handleCancel}
                disableCancel={disableCancel}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={6}>
                    </Col>
                    <Col md={6}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    checkBlankLocationEquipmentFields = () => {
        let form = this.state.form;
        if (!this.state.form.locationEquipment) {
            form.tangibleEquipmentAmount = null;
            form.personalLocation = false;
            form.businessLocation = false;
            form.warehouseLocation = false;
            form.garageLocation = false;
            form.mobileStorageLocation = false;
        }

        this.updatePostData(form, true)
    }

    renderForm() {
        
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <h3 style={{ marginTop: "0px", position: "relative" }}>
                            <AdminAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.setupProps.daysOpen} certificationType={this.state.form.certificationType} certificationStatus={this.state.form.certificationStatus} />
                        </h3>
                        <hr />
                        <h3 style={{ marginTop: "0px" }}>
                            Asset Purchase Agreement and Receipts – <small>Please submit all required Asset Purchase Agreement(s) and Receipt(s)</small>
                            {this.renderAdminStepToolbar()}
                            {this.state.form.allowPrinting && <div className="pull-right"><ActionButton id="btnPrint" onClick={this.handlePrint} icon="print" bsSize="sm">Print</ActionButton></div>}
                        </h3>
                        <hr />
                    </Col>
                </Row>
                <Row>
                    <Col md={7}>
                        {this.state.form.apaDocuments != null &&
                            this.state.form.apaDocuments.length > 0 && (
                                <FormGroup>
                                    <Label htmlFor="apaUpload" tip={this.setTip(TooltipCode.EQUIPMENT.ACTIVEASSETAGR)} required>Active Asset Agreement or Contracts over $3,000</Label>
                                    {this.renderApaDocuments()}
                                    {this.state.enabled && (this.state.form.apaDocuments == null || this.state.form.apaDocuments.length < 5) &&
										<Button type="button" bsStyle="link" onClick={this.addApaDocument}>
                                            Add another Asset Purchase Agreement
										</Button>
									}
                                </FormGroup>
                            )}
                        <br></br>
                        {this.state.form.elaDocuments != null &&
                            this.state.form.elaDocuments.length > 0 && (
                                <FormGroup>
                                    <Label htmlFor="elaUpload" tip={this.setTip(TooltipCode.EQUIPMENT.EQUIPMENTLEASEAGR)} required>Equipment Lease Agreement</Label>
                                    {this.renderElaDocuments()}
                                    {this.state.enabled && (this.state.form.elaDocuments == null || this.state.form.elaDocuments.length < 5) &&
										<Button type="button" bsStyle="link" onClick={this.addElaDocument}>
                                            Add another Equipment Lease Agreement
										</Button>
									}
                                </FormGroup>
                            )}
                    </Col>
                    <Col md={5}>
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Row>
                                        <Col md={12}>
                                            <Label htmlFor="locationEquipment" tip={this.setTip(TooltipCode.EQUIPMENT.EQUIPMENTLOC)}>Does your Company carry or hold any equipment or inventory at a location?</Label>
                                            <Switch name="locationEquipment" labelLeft="No" labelRight="Yes" bsStyle="success" />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            {this.state.form !== null && this.state.form.locationEquipment ?
                                                (
                                                    <React.Fragment>
                                                        <Row>
                                                            <Col md={7}>
                                                                <Label htmlFor="tangibleEquipmentAmount" tip={this.setTip(TooltipCode.EQUIPMENT.DOLLARAMOUNTEQINV)} required>Dollar Amount of Equipment or Inventory</Label>
                                                            </Col>
                                                            <Col md={5}>
                                                                <CurrencyBox
                                                                    name="tangibleEquipmentAmount"
                                                                    placeholder="Whole numbers only"
                                                                    positiveNumbersOnly
                                                                    precision={0}
                                                                    maxLength={10} />
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={12}>
                                                                <h4>Located At</h4>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={8}>
                                                                <Label htmlFor="personalLocation" tip={this.setTip(TooltipCode.EQUIPMENT.PERSONALHOMERES)}>Personal Home/Residence?</Label>
                                                            </Col>
                                                            <Col md={4}>
                                                                <Switch name="personalLocation" labelLeft="No" labelRight="Yes" bsStyle="primary" />
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={8}>
                                                                <Label htmlFor="businessLocation" tip={this.setTip(TooltipCode.EQUIPMENT.COMPANYLOC)}>Company location?</Label>
                                                            </Col>
                                                            <Col md={4}>
                                                                <Switch name="businessLocation" labelLeft="No" labelRight="Yes" bsStyle="primary" />
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={8}>
                                                                <Label htmlFor="warehouseLocation" tip={this.setTip(TooltipCode.EQUIPMENT.WAREHOUSELOC)}>Other Warehouse or Storage Facility?</Label>
                                                            </Col>
                                                            <Col md={4}>
                                                                <Switch name="warehouseLocation" labelLeft="No" labelRight="Yes" bsStyle="primary" />
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={8}>
                                                                <Label htmlFor="garageLocation" tip={this.setTip(TooltipCode.EQUIPMENT.GARAGELOC)}>Other Garage or Maintenance Facility?</Label>
                                                            </Col>
                                                            <Col md={4}>
                                                                <Switch name="garageLocation" labelLeft="No" labelRight="Yes" bsStyle="primary" />
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={8}>
                                                                <Label htmlFor="mobileStorageLocation" tip={this.setTip(TooltipCode.EQUIPMENT.MOBILESTORAGELOC)}>Mobile Storage Unit (Container, POD, Truck, etc.)?</Label>
                                                            </Col>
                                                            <Col md={4}>
                                                                <Switch name="mobileStorageLocation" labelLeft="No" labelRight="Yes" bsStyle="primary" />
                                                            </Col>
                                                        </Row>
                                                    </React.Fragment>)
                                                : null}
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                        </Row>

                    </Col>
                </Row>
                {
                    this.state.form.showReview ?
                        <React.Fragment>
                            <Row>
                                <CommentsGrid
                                    ref={(c) => { this._commentsGrid = c }}
                                    comments={this.state.form.comments}
                                    documents={this.state.form.reviewDocuments}
                                    certificationKey={this.props.selectedId}
                                    reviewTypeCode={"EQ"}
                                    queueTypeCode={this.state.form.certificationQueueTypeCode}
                                    enableExport={true}
                                    entityId={this.state.form.savedEntityId}
                                    readonly={!this.state.privileges.edit || !this.state.enabled}
                                    onSave={this.handleCommentsGrid}
                                    onCommentChange={this.handleCommentChange} />
                            </Row>
                            {this.state.form.showComplete ?
                                <Row>
                                    <ReviewPanel stepName="Equipment Information"
                                        canComplete={
                                            (
                                                this.state.form.certificationQueueTypeCode !== QueueType.APPLICATION_REVIEW.code &&
                                                this.state.form.certificationQueueTypeCode !== QueueType.CERTIFICATION_REVIEW.code &&
                                                this.state.form.certificationQueueTypeCode !== QueueType.COMMITTEE_REVIEW.code
                                            ) ||
                                            (this.state.form.apaDocuments.every((document) => { return document.uploadModel && document.uploadModel.validDocument; })
                                                && this.state.form.elaDocuments.every((document) => { return document.uploadModel && document.uploadModel.validDocument; }))}
                                        onChange={this.handleReviewStatus}
                                        reviewStatus={this.state.form.reviewStatus} />
                                </Row>
                                : null}
                        </React.Fragment> 
                        : null}
            </React.Fragment >
        )
    }
}

export default EquipmentInfo; 



// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/equipmentInfo/EquipmentInfo.js